// graphs
import generateBarChart from "./barChart";

const initializeGraphs = (container, graphs) => {
	const { data } = graphs;

	const mostActiveUsers = data.get("data");
	generateBarChart(container, mostActiveUsers.toJS(), "count");
};

export default initializeGraphs;
